import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getTimelineTasksAssignmentHours = async (
  projectId,
  timelineId
) => {
  const apiPath = `timelines/project/${projectId}/timeline/${timelineId}/timeline-tasks-assignment-hours`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
  });

  const response = await axios(signedRequest);

  return response.data;
};
